module.exports = __webpack_public_path__ + "static/img/login_tit.5883b45f.png";